import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useState } from 'react';

import { getTokenExpirationDate } from '../../../apis/tax-reporting-service/api';
import { getTokenStatus, TokenStatus } from '../utils';

export const useTokenStatus = (merchantId: string, country: string) => {
  const [status, setStatus] = useState<TokenStatus | string>('');
  const [daysAfterTokenExpires, setDaysAfterTokenExpires] = useState(0);
  const isEnabled = !!merchantId && country === 'ISR';
  const { isLoading, error } = useQuery(['tokenExpirationDate', merchantId], () => getTokenExpirationDate(merchantId), {
    enabled: isEnabled,
    refetchOnWindowFocus: false,
    onError: (error: AxiosError) => {
      /*
          If the user has not logged in yet then the GET endpoint will return 404, which means we show the initial message.
        */
      if (!!error.response && error.response.status === 404) {
        setStatus(TokenStatus.INITIAL);
      }
    },
    onSuccess: data => {
      const result = getTokenStatus(data.expires_at);
      const { status: tokenStatus, daysAfterTokenExpires: remainingDays } = result;
      setStatus(tokenStatus);
      setDaysAfterTokenExpires(remainingDays);
    },
  });
  return { status, daysAfterTokenExpires, loading: isEnabled && isLoading, error };
};
